import React, { useState } from 'react';
import { Optimizations } from 'src/features/MO/components/templates/Optimizations';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { MOFilterBar } from '../../features/MO/components/organisms/MOFilterBar';

export const OptimizationPage: React.FC = () => {
  const [isCreateOptimizationOpen, setIsCreateOptimizationOpen] =
    useState(false);

  return (
    <PageModelLayout
      extraButtons={
        isCreateOptimizationOpen ? null : (
          <MOFilterBar onClick={() => setIsCreateOptimizationOpen(true)} />
        )
      }
      pageTitle={
        isCreateOptimizationOpen
          ? 'Create Optimization'
          : 'Marketing Optimization'
      }>
      <Optimizations
        isCreateOptimizationOpen={isCreateOptimizationOpen}
        onClose={() => setIsCreateOptimizationOpen(false)}
      />
    </PageModelLayout>
  );
};
